"use strict";
var fails = require("../internals/fails");
module.exports = !fails(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
});
